import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../Login/components/layout";
import StripeConnectResultPage from "../../components/stripeConnect";

const StripeConnectResultContainer = () => (
  <main>
    <Helmet title="Stripe Connection">
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <Layout>
      <StripeConnectResultPage />
    </Layout>
  </main>
);

export default StripeConnectResultContainer;
